module.exports = __webpack_public_path__ + "img/4.0ad39b74.jpg";